import React, {useEffect, useRef, useState} from 'react'
import classes from "./style.module.scss"
import useStyles from 'isomorphic-style-loader/useStyles'
import { useDispatch, useSelector } from 'react-redux'
import { useStore } from 'react-redux'
import { useHistory, useParams } from 'react-router-dom'
import { useQuery } from '../../../../../hooks/common'
import { FormattedMessage, useIntl } from 'react-intl'
import MeChildHeader from '../../../components/me-child-header'
import MeLoading from '../../../components/loading'
import { action_fetch_customer, action_fetch_obj_message } from '../../../../../../store/actions/pages/customer'
import { BigButton } from '../../../../../components/button'
import NormalConfigConfirm from '../../../../../../client/components/alert/config-confirm'
import { updateCustomerSave } from '../../../../../../api'
import Toast from '../../../../../components/toast'
import PointsReminderModal from '../../../components/points-reminder-modal'

const Item = props => {
    const {title, labelList, favoriteList, itemSelect} = props || {}

    const verifyActive = (value) => {
        return favoriteList?.findIndex(item => item.value == value) >= 0
    }

    return (
        <div className={classes.Item}>
            <div className={classes.Title}>
                {title}
            </div>

            <div className={classes.LabelList}>
                {
                    labelList?.map((item, index) => (
                        <div className={`${classes.Label} ${verifyActive(item?.value) ? classes.Active: ''}`}
                             key={item?.value + index}
                             onClick={() => itemSelect(item)}
                             >
                            {item?.value}
                        </div>
                    ))
                }
            </div>
        </div>
    )
}

const MyPreference  = props => {
    useStyles(classes)
    const [loading, setLoading] = useState(true)
    const store = useStore()
    const params = useParams()
    const query = useQuery()
    const dispatch = useDispatch()
    const Intl = useIntl()

    const pageCustomer = useSelector(state => state.pageCustomer)
    const { customer, message } = pageCustomer || {}
    const { M1521: preferenceMessage } = message || {}
    const { myPreference } = customer || {}

    const [ myPreferenceData, setMyPreferenceData ] = useState('')
    const [reminderMessage, setReminderMessage] = useState('')

    useEffect(() => {
        if(myPreference){
            setMyPreferenceData({...myPreference})
        }
    }, [myPreference])

    useEffect(async () => {
        if (window.__INITIAL_STATE__) {
			// Allow the passed state to be garbage-collected
			delete window.__INITIAL_STATE__
		} else {
			await MyPreference.fetchData(store, params, query)
		}
    }, [customer?.id])

    useEffect(() => {
        if(customer?.id){
            setLoading(false)
        } else {
            setTimeout(() => {
                setLoading(false)
            }, 5000)
        }
    },[customer])

    useEffect(() => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        })
    }, [])


    const itemSelect = (e, type) => {
        let list = myPreferenceData?.[type+''] || []
        if(list?.findIndex(l => l?.value === e?.value) >=0){
            list = list.filter(l => l?.value != e?.value)
        } else {
            list.push(e)
        }
        let obj = {}
        obj[type] = list
        setMyPreferenceData({...myPreferenceData, ...obj})
    }

    const disposeCustomer = arr => {
        // return arr?.length > 0 ? arr: ''
        if(arr?.length > 0){
            return arr.map(item => item?.value)
        }
        return []
    }

    const saveHandle = async () => {
        setLoading(true)
        const [favoriteCategories, usuallyBuyClothesFor, favoriteStyles] = [
                disposeCustomer(myPreferenceData?.favoriteCategories),
                disposeCustomer(myPreferenceData?.usuallyBuyClothesFor),
                disposeCustomer(myPreferenceData?.favoriteStyles)
            ]
        if(favoriteCategories?.length <= 0 && usuallyBuyClothesFor?.length <= 0 && favoriteStyles?.length <= 0){
            setLoading(false)
            NormalConfigConfirm({
                boxStyle:{
                    padding:"25px",
                },
                message:{
                    text:  Intl.formatMessage({id: 'preference_cannot_empty'}),
                    style:{
                        fontFamily: 'Roboto',
                        fontSize: '14px',
                        lineHeight: 'normal',
                        color:'#222222',
                        textAlign: 'center'
                    },
                    html:false
                }
            })
            return
        }

        let obj = {
            customer:{
                myPreference:{
                    "favoriteCategories": favoriteCategories,
                    "usuallyBuyClothesFor": usuallyBuyClothesFor,
                    "favoriteStyles": favoriteStyles
                }
            },
            name:"myPreference",
            definition:{ myPreference: myPreferenceData}
        };

        const response = await updateCustomerSave(obj)
        setLoading(false)
        if(response?.code == 200){
            if(response?.prompt?.html){
                setReminderMessage(response?.prompt?.html)
                await dispatch(action_fetch_customer())
            } else {
                Toast(Intl.formatMessage({id: 'save_successful'}))
                await dispatch(action_fetch_customer())
            }
        } else {
            alert(response?.result || response)
        }
    }

    return (
        <div className={classes.MyPreferencePage}>
            <MeChildHeader name={Intl.formatMessage({id: 'my_preference'})}/>

            <div style={{backgroundColor: '#fff', paddingBottom:"10px"}}>
                {
                    preferenceMessage?.favoriteCategories?.length > 0 ?
                    <Item
                        title={Intl.formatMessage({id: 'which_catehories_you_favor'})}
                        labelList={preferenceMessage?.favoriteCategories}
                        favoriteList={myPreferenceData?.favoriteCategories}
                        itemSelect={e => itemSelect(e, 'favoriteCategories')}
                        />:
                    <React.Fragment></React.Fragment>
                }

                {
                    preferenceMessage?.usuallyBuyClothesFor?.length > 0 ?
                    <Item
                        title={Intl.formatMessage({id: 'who_you_buy_clothes_for'})}
                        labelList={preferenceMessage?.usuallyBuyClothesFor}
                        favoriteList={myPreferenceData?.usuallyBuyClothesFor}
                        itemSelect={e => itemSelect(e, 'usuallyBuyClothesFor')}
                        />:
                    <React.Fragment></React.Fragment>
                }

                {
                    preferenceMessage?.favoriteStyles?.length > 0 ?
                    <Item
                        title={Intl.formatMessage({id: 'which_style_you_favor'})}
                        labelList={preferenceMessage?.favoriteStyles}
                        favoriteList={myPreferenceData?.favoriteStyles}
                        itemSelect={e => itemSelect(e, 'favoriteStyles')}
                        />:
                    <React.Fragment></React.Fragment>
                }
            </div>

            <div className={classes.SignOutButton}>
                <BigButton onClick={saveHandle}><FormattedMessage id="save" defaultMessage="Save"/></BigButton>
            </div>

            {
                reminderMessage ?
                <PointsReminderModal reminderMessage={reminderMessage} onClose={() => setReminderMessage('')}/>:
                <React.Fragment></React.Fragment>
            }

            <MeLoading loading={loading}/>
        </div>
    )
}


MyPreference.fetchData = async (store, params, search, headers) => {
    await store.dispatch(action_fetch_obj_message('M1521', headers))
}

export default MyPreference